export default __webpack_public_path__ + "static/media/linkedin.f796ec99.svg";